import Stage from './Stage'

export default Stage
